<template>
  <section class="register-2">
    <div class="container-scroller">
      <div class="container-fluid page-body-wrapper full-page-wrapper p-0">
        <div
          class="content-wrapper d-flex align-items-stretch auth auth-img-bg"
          style="overflow: hidden"
        >
          <div class="row flex-grow">
            <div
              class="col-lg-5 register-form-left d-flex align-items-center justify-content-center"
            >
              <div class="brand-logo auth-form-transparent col-md-12 col-lg-9">
                <router-link :to="{ name: 'SmartOeeLogin' }">
                  <img :src="require('@/assets/images/logo3.png')" alt="logo" />
                </router-link>
              </div>
              <div
                class="width-form custom-margin-register-form pt-5 pt-lg-0 mt-md-5 mb-md-3 mb-lg-0"
              >
                <div class="auth-form-transparent text-left pt-5 pt-md-0 px-0 col-md-12 col-lg-9">
                  <h4>{{ $t('register.title') }}</h4>
                  <h6 class="font-weight-light mb-4">{{ $t('register.subtitle') }}</h6>
                  <b-alert v-model="isError" variant="danger">{{ error }}</b-alert>

                  <smart-oee-user-register-form
                    @submit="submitUserForm"
                  ></smart-oee-user-register-form>
                  <div class="text-center mt-4 font-weight-light mb-3 mb-md-0">
                    {{ $t('register.form.footer.accountMsg') }}
                    <router-link :to="{ name: 'SmartOeeLogin' }" class="text-primary">
                      {{ $t('register.form.footer.loginLink') }}
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="col-lg-7 col-md-12 login-half-bg d-flex align-items-center justify-content-center"
            >
              <text-for-login-register-page></text-for-login-register-page>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import registerUserMutation from '@/api/user/mutations/registerUser.gql';
import registerPmMutation from '@/api/user/mutations/registerPm.gql';
export default {
  name: 'SmartOeeRegister',
  data() {
    return {
      registerError: '',
    };
  },
  computed: {
    isError() {
      return !!this.registerError;
    },
    error() {
      return this.registerError;
    },
  },
  methods: {
    submitUserForm(form) {
      this.registerError = '';

      this.$apollo
        .mutate({
          mutation: registerUserMutation,
          variables: {
            firstName: form.name,
            lastName: form.surname,
            email: form.email,
            phone: form.phone,
          },
        })
        .then(() => {
          this.$store.commit('SET_PROCESSING', false);
          this.$router.push({
            name: 'VerifyEmail',
          });
        })
        .catch((e) => {
          this.$store.commit('SET_PROCESSING', false);
          this.registerError = e.message;
        });
    },
    submitPmForm(form) {
      this.registerError = '';

      this.$apollo
        .mutate({
          mutation: registerPmMutation,
          variables: {
            firstName: form.name,
            lastName: form.surname,
            email: form.email,
            phone: form.phone,
            orgName: form.company,
            okpo: form.okpo,
          },
        })
        .then(() => {
          this.$store.commit('SET_PROCESSING', false);
          this.$router.push({
            name: 'VerifyEmail',
          });
        })
        .catch((e) => {
          this.$store.commit('SET_PROCESSING', false);
          this.registerError = e.message;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.register-tabs {
  margin-top: 0.5rem;
}
.register-form-left {
  position: relative;
  background-color: #191c24;
  .brand-logo {
    position: absolute;
    top: 35px;
  }
}
@media (min-width: 768px) {
  .width-form {
    width: 100%;
  }
}
@media (max-width: 767.9px) {
  .register-form-left {
    .brand-logo {
      left: 10%;
    }
  }
  .width-form {
    width: 75%;
    margin-top: 50px;
  }
}
@media (min-width: 992px) {
  .custom-margin-register-form {
    margin-top: 60px !important;
  }
}
</style>
